/* Language Texts Exam Portal Administration */

export const en = {
	/* Menu Items */
	'menu.serviceagreement': 'Service agreement',
	'menu.statusServiceAgreementGreen': 'Agreement status: Up to date',
	'menu.status statusServiceAgreementRed': 'Agreement status: Expired',
	'menu.statusServiceAgreementYellow': 'Agreement status: Overdue',
	'menu.certification': 'Pending Digital Certification',
	'menu.newReport': 'New Manual Report',
	'menu.discardMaterial': 'Material Disposal',
	'menu.messages': 'Messages',
	'menu.start': 'Start',
	'menu.retreat': 'Retreat',
	'menu.graphics': 'Graphics',
	'menu.histology': 'Histology',
	'menu.generalCytology': 'General Cytology',
	'menu.immunology': 'Immunology - Slides',
	'menu.taskControl': 'Task Control',
	'menu.doctorTasks': 'Doctor Tasks',
	'menu.materialDisposal': 'Material disposal',
	'menu.archivingRequisitionMaterials':
		'Archiving and Requisition of Materials',
	'menu.reports': 'Reports',
	'menu.requestsPanel': 'Requests Panel',
	'menu.version': 'Version',
	'menu.integratesoul': 'Soul Integration',

	/* Links */
	'link.integratesoul.cas': 'Soul',
	'link.integratesoul.insurance': 'Billing Health insurance',
	'link.integratesoul.sus': 'Billing SUS',
	'link.integratesoul.pep': 'Pep',
	'link.integratesoul.psdi': 'Psdi',

	/* Protocol */
	'protocol.ventana': 'Ventana integration',
	'protocol.date': 'Date',
	'protocol.doctor': 'Doctor',
	'protocol.case': 'Case',
	'protocol.protocol': 'Protocol',
	'protocol.blade': 'Blade',
	'protocol.sent': 'Sent',
	'protocol.recognized': 'Recognized',
	'protocol.chanting': 'blushing',
	'protocol.flushed': 'Flushed',
	'protocol.finished': 'Finished',

	/* Login screen */

	'general.title': 'Pathological Anatomy',
	'general.title-min': 'Anatomy',
	'general.copyright': 'MV Sistemas © 2024 All rights reserved',
	'general.user': 'User',
	'general.password': 'Password',
	'general.incorrectPassword': 'Incorrect password. Try again.',
	'general.incorrectUser': 'Incorrect user. Try again.',
	'general.accessAccount': 'Use your account to access the ',
	'general.logIn': 'Log in',
	'general.forgotPassword': 'Forgot password?',
	'general.version': 'Version:',
	'general.about': 'About',
	'general.help': 'Help',
	'general.login.next': 'Next',
	'general.login.back': 'Back',
	'general.login.wellcome': 'Welcome',
	'general.login.email': 'Email',
	'general.login.text': 'Use your account to login ',
	'general.login.mail.recovery':
		'Enter your email and we will send you a link to change your password',
	'general.login.newaccount': 'New Account',
	'general.login.select.company': 'Select a Company',
	'general.protocol.ventana': 'Ventana Integrate',
	'general.login.lowercasePasswordLabel': 'At least one lowercase letter',
	'general.login.uppercasePasswordLabel': 'At least one uppercase letter',
	'general.login.numberPasswordLabel': 'At least one number',
	'general.login.characterPasswordLabel': 'At least one character',
	'general.login.lenghtEightPasswordLabel': 'At least 8 characters long',
	'general.login.placeholdPasswordConfirm': 'Confirm Password',
	'general.login.passwordMustBeEqual': 'Passwords must be equal',

	/* 01.Start, Filters, Search and Result */

	'dashboards.general.pt': 'Portuguese (Brazil)',
	'dashboards.general.en': 'English (International)',
	'dashboards.general.es': 'Spanish',
	'dashboards.general.logout': 'Logout',
	'dashboards.general.settings': 'Settings',
	'dashboards.general.patientBusinessName': 'Patient (Social Name)',
	'dashboards.general.medicalRecord': 'Medical record',
	'dashboards.general.examNumber': 'N° Exam',
	'dashboards.general.attendance': 'Attendance',
	'dashboards.general.search': 'Search',
	'dashboards.general.currentFilter': 'Save current filter',
	'dashboards.general.recordsFound': 'Records found',
	'dashboards.general.orderBy': 'Order by:',
	'dashboards.general.ascendingOrder': 'Ascending Order',
    'dashboards.general.descendingOrder': 'Descending Order',
	'dashboards.general.filterBy': 'Filter by:',
	'dashboards.general.approvalEnvironment': 'APPROVAL ENVIRONMENT',
	'dashboards.general.clearFilters': 'Clear filters',
	'dashboards.general.noFilteredItems': 'No filtered items',
	'dashboards.general.knowledgeBase': 'Knowledge base',
	'dashboards.general.title': 'Pathological Anatomy',
	'dashboards.general.orderNumber': 'Order number',
	'dashboards.general.expectedDeliveryDate': 'Expected Delivery Date',
	'dashboards.general.expectedDelivery': 'Expected Delivery Date',
	'dashboards.general.requestDate': 'Request Date',
	'dashboards.general.deliveryDate': 'Delivery Date',
	'dashboards.general.urgent': 'Urgent',
	'dashboards.general.immunohistochemistryTests': 'Immunohistochemistry tests',
	'dashboards.general.socialName': 'Social Name',
	'dashboards.general.accessionNumber': 'Access number',
	'dashboards.general.attendance': 'Attendance',
	'dashboards.general.active': 'Active',
	'dashboards.general.SUSnationalCard': 'SUS National Card',
	'dashboards.general.healthInsurance': 'Health Insurance',
	'dashboards.general.deliveryDate': 'Delivery Date',
	'dashboards.general.releaseDate': 'Release Date',
	'dashboards.general.datenonCompliance': 'Date non Compliance',
	'dashboards.general.requestDate': 'Request Date',
	'dashboards.general.diagnosis': 'Diagnosis',
	'dashboards.general.forwarding': 'Forwarding',
	'dashboards.general.exams': 'Exams',
	'dashboards.general.examGroup': 'Exam Group',
	'dashboards.general.report': 'Report',
	'dashboards.general.sameEnrollment': 'SAME Enrollment',
	'dashboards.general.performingPhysician': 'Performing Physician',
	'dashboards.general.medicalReviewer': 'Medical Reviewer',
	'dashboards.general.requestingDoctor': 'Requesting Doctor',
	'dashboards.general.certifyingDoctor': 'Certifying Doctor',
	'dashboards.general.nonCompliance': 'Non Compliance',
	'dashboards.general.externalExamNo': 'External Exam No.',
	'dashboards.general.examNumber': 'Exam Number',
	'dashboards.general.orderNumber': 'Order Number',
	'dashboards.general.observationReport': 'Observation Report',
	'dashboards.general.pacient': 'Pacient',
	'dashboards.general.procedure': 'Procedure',
	'dashboards.general.medicalRecord': 'Medical Record',
	'dashboards.general.nonconformityResolution': 'Non Conformity Resolution',
	'dashboards.general.requestingSector': 'Requesting Sector',
	'dashboards.general.stepStatus': 'Step Status',
	'dashboards.general.examType': 'Exam Type',
	'dashboards.general.nonconformityType': 'Non Conformity Type',
	'dashboards.general.topography': 'Topography',
	'dashboards.general.serviceUnit': 'Service Unit',
	'dashboards.general.urgent': 'Urgent',
	'dashboards.general.consultationGreater6Months':
		'Consultation period greater than 6 months',
	'dashboards.general.consultationGreater1Year':
		'Consultation period greater than 1 year',
	'dashboards.general.startDateGreaterEndDate.':
		'The start date is greater than the end date.',
	'dashboards.general.enterValidEndDate': 'Please enter a valid end date!',
	'dashboards.general.sampleReceipt': 'Sample Receipt',
	'dashboards.general.email': 'Sending Email',
	'dashboards.general.certification': 'Digital certification',
	'dashboards.general.certificationTab': 'Certification',
	'dashboards.general.personalizedExam':
		'I want to generate the custom exam number',
	'dashboards.general.initials': 'Initials:',
	'dashboards.general.selectInitials': 'Select position of acronym',
	'dashboards.general.sequence': 'Sequence:',
	'dashboards.general.selectSequence': 'Select sequence position',
	'dashboards.general.currentYear': 'Current year:',
	'dashboards.general.selectCurrentYear': 'Select year position',
	'dashboards.general.separator': 'Separator:',
	'dashboards.general.selectSeparator': 'Select separator position',
	'dashboards.general.exampleNumber': 'The exam number will be as follows:',
	'dashboards.general.resultExam':
		'Print protocol upon delivery of the exam result',
	'dashboards.general.printStep': 'Print report grouped by stage',
	'dashboards.general.stepNameNotes':
		'Enter the name you want for the Notes stage',
	'dashboards.general.addendum': 'Addendum',
	'dashboards.general.firstPosition': 'First position',
	'dashboards.general.secondPosition': 'Second position',
	'dashboards.general.thirdPosition': 'Third position',
	'dashboards.general.fourthPosition': 'Fourth position',
	'dashboards.general.onCheckList': 'Enable checklist for material receipt',
	'dashboards.general.printLabel': 'Print label after finalizing receipt',
	'dashboards.general.pickupScreen':
		'Open sample collection screen after completion of receipt',
	'dashboards.general.standardDoctorBill':
		'Always bill using the default performing physician',
	'dashboards.general.emailSender': 'Sender (Email):',
	'dashboards.general.password': 'Password:',
	'dashboards.general.smtp': 'SMTP:',
	'dashboards.general.door': 'Door:',
	'dashboards.general.enabledigitalCertification':
		'Enable Digital Certification',
	'dashboards.general.HSM': 'Use HSM',
	'dashboards.general.urldigitalRegistry': 'Url of the Digital Registry:',
	'dashboards.general.shippingType': 'Shipping Type:',
	'dashboards.general.digitalNotaryVersion': 'Digital Notary Version:',
	'dashboards.general.addFilters': 'Add other filters',
	'dashboards.general.noFilter': 'No filters available',
	'dashboards.general.favoriteFilter': 'Favorite filters',
	'dashboards.general.noFilterCreated': 'No favorites have been created yet',
	'dashboards.general.savedFilter': 'Save current filter as favorite',
	'dashboards.general.filterTitle': 'Enter a title for the favorite filter',
	'dashboards.general.patternDoctor': 'Standard doctor',
	'dashboards.general.maximumNumberBlades':
		'Maximum number of slides for reading:',
	'dashboards.general.enableContinuousGeneration':
		'Enable continuous generation of Cassette numbering',
	'dashboards.general.resultSearch': 'Search Result',
	'dashboards.general.toView': 'To view',
	'dashboards.general.fillField': 'Fill this field',
	'dashboards.general.occurrencesReports': 'Reports Occurrences:',
	'dashboards.general.today': 'Today',
	'dashboards.general.yesterday': 'Yesterday',
	'dashboards.general.beforeYesterday': 'Before yesterday',
	'dashboards.general.oneWeekAgo': '1 Week ago',
	'dashboards.general.week': 'Week',
	'dashboards.general.month': 'Month',
	'dashboards.general.fifteenDaysAgo': '15 Days ago',
	'dashboards.general.aMonthAgo': '1 Month ago',
	'dashboards.general.twoMonthsAgo': '2 Months ago',
	'dashboards.general.threeMonthsAgo': '3 Months ago',
	'dashboards.general.sixMonthsAgo': '6 Months ago',
	'dashboards.general.aYearAgo': '1 Year ago',
	'dashboards.general.other': 'Other',
	'dashboards.general.selectPeriod': 'Select a period',
	'dashboards.general.informValidStartDate': 'Enter a valid start date',
	'dashboards.general.informValidEndDate': 'Enter a valid end date',
	'dashboards.general.CPF': 'SSN',
	'dashboards.general.birthDate': 'Date of birth',

	/* 02.Exam Details, Report and Editor */

	'dashboards.examDetails.linkExams': 'Link exams:',
	'dashboards.examDetails.socialName': 'Social Name: ',
	'dashboards.examDetails.exam': 'Exam: ',
	'dashboards.examDetails.numberExam': 'Exam number: ',
	'dashboards.examDetails.birthDate': 'Date of birth: ',
	'dashboards.examDetails.sex': 'Sex: ',
	'dashboards.examDetails.previousExamNumber': 'Previous exam number: ',
	'dashboards.examDetails.completionDate': 'Completion Date ',
	'dashboards.examDetails.orderDate': 'Order Date: ',
	'dashboards.examDetails.request': 'Request: ',
	'dashboards.examDetails.attendance': 'Attendance: ',
	'dashboards.examDetails.attendanceType': 'Attendance type',
	'dashboards.examDetails.attendanceDate': 'Attendance date',
	'dashboards.examDetails.healthInsurance': 'Health insurance: ',
	'dashboards.examDetails.canceled': 'Canceled ',
	'dashboards.examDetails.messages': 'Message ',
	'dashboards.examDetails.block': 'Block Qty: ',
	'dashboards.examDetails.blade': 'Blade Qty: ',
	'dashboards.examDetails.externalExam': 'External Exam No.: ',
	'dashboards.examDetails.urgent': 'Urgent',
	'dashboards.examDetails.criticalReport': 'Critical Report',
	'dashboards.examDetails.changeOfUrgency':
		'Confirm the change in the urgency of this report?',
	'dashboards.examDetails.changeInCriticality':
		'Confirm the change in the criticality of this report?',
	'dashboards.examDetails.justification': 'Justification:',
	'dashboards.examDetails.cancel': 'Cancel',
	'dashboards.examDetails.confirm': 'Confirm',
	'dashboards.examDetails.patientCriticalReport':
		'Patient with a history of critical report',
	'dashboards.examDetails.requestingDoctor': 'Physician Request:',
	'dashboards.examDetails.examRequest': 'Exam Request:',
	'dashboards.examDetails.expectedDeliveryDate': 'Expected Delivery Date:',
	'dashboards.examDetails.released': 'RELEASED',
	'dashboards.examDetails.autoText': 'Auto text',
	'dashboards.examDetails.attachments': 'Attachments',
	'dashboards.examDetails.previousReports': 'Previous reports',
	'dashboards.examDetails.reportHistory': 'Report history',
	'dashboards.examDetails.bladeList': 'Blade list',
	'dashboards.examDetails.status.nonCompliance': 'Non Compliance',
	'dashboards.examDetails.status.nochecked': 'No checked',
	'dashboards.examDetails.status.pending': ' Pending',
	'dashboards.examDetails.status.checked': 'Checked',
	'dashboards.examDetails.status.revision': 'Revision',
	'dashboards.examDetails.status.notApplicable': 'Not Applicable',
	'dashboards.examDetails.status.lecturer': 'Lecturer',
	'dashboards.examDetails.step.material': 'MATERIAL',
	'dashboards.examDetails.step.macro': 'MACRO',
	'dashboards.examDetails.step.micro': 'MICRO',
	'dashboards.examDetails.step.imuno': 'IMMUNE',
	'dashboards.examDetails.step.histo': 'HISTO',
	'dashboards.examDetails.step.cish': 'CISH',
	'dashboards.examDetails.step.fish': 'FISH',
	'dashboards.examDetails.step.pcr': 'PCR',
	'dashboards.examDetails.step.congelacao': 'FREEZING',
	'dashboards.examDetails.step.conclusao': 'CONCLUSION',
	'dashboards.examDetails.step.errata': 'ERRATA/ADDITIONAL INFORMATION',
	'dashboards.examDetails.cid': 'CID',
	'dashboards.examDetails.traceability': 'Traceability',
	'dashboards.examDetails.invoicing': 'Invoicing',
	'dashboards.examDetails.resultDelivery': 'Exam result delivery',
	'dashboards.examDetails.printStep': 'Print Step',
	'dashboards.examDetails.printLabels': 'Print Labels',
	'dashboards.examDetails.includeRemarks': 'Include remarks',
	'dashboards.examDetails.protocolRequirements': 'Protocol requirements',
	'dashboards.examDetails.freezingRequest': 'Freezing request',
	'dashboards.examDetails.releaseReport': 'Release Report',
	'dashboards.examDetails.blockBladeControl': 'Block and Blade Control',
	'dashboards.examDetails.sendEmail': 'Send Email',
	'dashboards.examDetails.reopenSteps': 'Reopen steps',
	'dashboards.examDetails.openExams': 'Open exams',
	'dashboards.examDetails.examLinked': 'Exam with linked report',
	'dashboards.examDetails.nextDeliveryDate': 'Next delivery date',
	'dashboards.examDetails.criticalReport': 'Critical report',
	'dashboards.examDetails.urgentExam': 'Urgent exam',
	'dashboards.examDetails.printedTermofConsent': 'Printed Term of Consent',
	'dashboards.examDetails.examDeliveredIn': 'Exam Delivered in: ',
	'dashboards.examDetails.billExams': 'Bill exams',
	'dashboards.examDetails.multipleExams': 'Multiple exams',
	'dashboards.examDetails.quantity': 'The amount:',
	'dashboards.examDetails.examStage': 'Exam step:',
	'dashboards.examDetails.invoice': 'Invoice',
	'dashboards.examDetails.manualDisabled': '* Manual billing disabled',
	'dashboards.examDetails.unbilledItems':
		'There are unbilled items, do you want to close anyway?',
	'dashboards.examDetails.yes': 'Yes',
	'dashboards.examDetails.no': 'No',
	'dashboards.examDetails.na': 'Not applicable',
	'dashboards.examDetails.changeswillbelost':
		'When closing all changes will be lost!',
	'dashboards.examDetails.applicablesteps':
		'* There are no applicable billing steps for this exam',
	'dashboards.examDetails.selectStage': 'Select exam step',
	'dashboards.examDetails.stageDoctor': 'Stage doctor:',
	'dashboards.examDetails.selectDoctorStage':
		'Select the doctor for this stage',
	'dashboards.examDetails.new': 'New',
	'dashboards.examDetails.changed': 'Changed',
	'dashboards.examDetail.doctorUndefined':
		'Doctor performing the undefined step!',
	'dashboards.examDetail.billed': 'Billed',
	'dashboards.examDetail.pendingBilling': 'Pending Billing',
	'dashboards.examDetail.thereWasProblem': 'There was a problem',
	'dashboards.examDetail.addExam': 'Add new exam',
	'dashboards.examDetail.viewadditionalinfo': 'view additional info',
	'dashboards.examDetail.selectExam': 'Select exam',
	'dashboards.examDetail.exams': 'Exams:',
	'dashboards.examDetail.multiploExams': 'Multiple exams:',
	'dashboards.examDetail.performingPhysician': 'Performing physician:',
	'dashboards.examDetail.selectDoctor': 'Select requesting physician',
	'dashboards.examDetail.annotationsExam': 'Exam notes:',
	'dashboards.examDetail.save': 'Save',
	'dashboards.examDetail.edit': 'Edit',
	'dashboards.examDetail.delete': 'Delete',
	'dashboards.examDetail.billExam': 'Bill exam',
	'dashboards.examDetail.cancelBilling': 'Cancel billing',
	'dashboards.examDetail.generate': 'Generate',
	'dashboards.examDetail.generateImpression': 'Generate impression',
	'dashboards.examDetail.printLabels': 'Print labels:',
	'dashboards.examDetail.selectAll': 'Select all',
	'dashboards.examDetail.bottle': 'Bottle: ',
	'dashboards.examDetail.controlLabel': 'Control label',
	'dashboards.examDetail.label': 'Labels',
	'dashboards.examDetail.comments': 'Observations',
	'dashboards.examDetail.reportObservation': 'Report your observation here',
	'dashboards.examDetail.patient': 'Patient:',
	'dashboards.examDetail.date': 'Date:',
	'dashboards.examDetail.numberOfExam': 'Exam number:',
	'dashboards.examDetail.topography': 'Topography:',
	'dashboards.examDetail.selectTopography': 'Select topography',
	'dashboards.examDetail.CID': 'CID:',
	'dashboards.examDetail.enter': 'Enter at least',
	'dashboards.examDetail.searchCharacters': 'characters in the search',
	'dashboards.examDetail.selectCID': 'Select the CID',
	'dashboards.examDetail.mainDiagnosis': 'Main Diagnosis (CID-O)',
	'dashboards.examDetail.annotations': 'Annotations',
	'dashboards.examDetail.generalObservations': 'General observations',
	'dashboards.examDetail.adding': 'Add',
	'dashboards.examDetail.close': 'Close',
	'dashboards.examDetail.cidTopography': 'CID/Topographies',
	'dashboards.examDetail.annotation': 'Annotation:',
	'dashboards.examDetail.toSave': 'Save',
	'dashboards.examDetail.mandatoryCID':
		'Mandatory to register CID for the report',
	'dashboards.examDetail.operation': 'Operation:',
	'dashboards.examDetail.sectorChange': 'Sector change',
	'dashboards.examDetail.user': 'User:',
	'dashboards.examDetail.action': 'Action:',
	'dashboards.examDetail.userJustification': 'User justification:',
	'dashboards.examDetail.requisitionFreezingReport':
		'Request for freezing report',
	'dashboards.examDetail.freezingBlock': 'Freezing Block:',
	'dashboards.examDetail.selectFreezingBlock':
		'Select a freezing block (optional)',
	'dashboards.examDetail.noFreezeBlock': 'No freezing blocks for this exam',
	'dashboards.examDetail.addBlock': '+ Block',
	'dashboards.examDetail.bladeAddOn': 'Blade complement',
	'dashboards.examDetail.selectBladeAddOn': 'Select blade complement',
	'dashboards.examDetail.registerNewAddOn': 'Register new add-on',
	'dashboards.examDetail.unconformities': 'Unconformities:',
	'dashboards.examDetail.selectUnconformities': 'Select unconformities',
	'dashboards.examDetail.freezingTechnician': 'Freezing Technician:',
	'dashboards.examDetail.selectTechnician': 'Select technician',
	'dashboards.examDetail.freezingPathologist': 'Freezing Pathologist:',
	'dashboards.examDetail.selectPathologist': 'Select pathologist',
	'dashboards.examDetail.clearFields': 'Clear fields',
	'dashboards.examDetail.listBlades': 'List Blades',
	'dashboards.examDetail.requester': 'Requester',
	'dashboards.examDetail.block': 'Block',
	'dashboards.examDetail.blade': 'Blade',
	'dashboards.examDetail.performSearch': 'Type something for the search',
	'dashboards.examDetail.noRecordFound': 'No record found',
	'dashboards.examDetail.qtyBlades': 'Qty. blades',
	'dashboards.examDetail.addBlade': 'Add Blade',
	'dashboards.examDetail.macroscopicMap': 'Macroscopic map',
	'dashboards.examDetail.technicalArea': 'Technical area',
	'dashboards.examDetail.generalCytology': 'General cytology',
	'dashboards.examDetail.freezing': 'Freezing',
	'dashboards.examDetail.blockandBladeControl': 'Block and Blade Control',
	'dashboards.examDetail.table.blade': 'Blade',
	'dashboards.examDetail.table.delegateTechnician': 'Delegate technician',
	'dashboards.examDetail.table.exam': 'Exam',
	'dashboards.examDetail.table.status': 'Status',
	'dashboards.examDetail.table.registrationDate': 'Registration date',
	'dashboards.examDetail.table.noResultsFound': 'No results found',
	'dashboards.examDetail.table.coloring': 'Coloring',
	'dashboards.examDetail.table.technician': 'Technician',
	'dashboards.examDetail.table.pathologist': 'Pathologist',
	'dashboards.examDetail.table.complement': 'Complement',
	'dashboards.examDetail.table.editComplement': 'Additions Edit',
	'dashboards.examDetail.cancelStep.confirm': 'Confirm reopening of steps',
	'dashboards.examDetail.cancelStep.confirmCancel':'Upon confirmation, the steps below will reopen',
	'dashboards.examDetail.cancelStep.select': 'Select the step',
	'dashboards.examDetail.cancelStep.selectStep': '- Select a step',
	'dashboards.examDetail.cancelStep.legends': 'Subtitles:',
	'dashboards.examDetail.cancelStep.stepsCompleted':
		'Steps that will remain completed',
	'dashboards.examDetail.cancelStep.stepsCanceled': 'Steps that will be reopened',
	'dashboards.examDetail.cancelStep.stepsNotAllowed': 'Steps not allowed reopening execution by user',
	'dashboards.examDetail.cancelStep.stepCancel': 'Reopen step(s)',
	'dashboards.examDetail.sendReportEmail': 'Send report by email -',
	'dashboards.examDetail.recipient': 'Recipient',
	'dashboards.examDetail.recipientEmail': 'Enter recipient email',
	'dashboards.examDetail.subject': 'Subject',
	'dashboards.examDetail.subjectEmail': 'Enter the subject of the email',
	'dashboards.examDetail.enterText': 'Enter a text...',
	'dashboards.examDetail.protocolRequestAvailable':
		'Protocol Request Available',
	'dashboards.examDetail.protocolRequirements':
		'Reporting protocol requirements',
	'dashboards.examDetail.antibodyInformed':
		'Antibody already informed. Do you want to launch again?',
	'dashboards.examDetail.errataInformed':
		'Deseja lançar a Errata para o laudo já concluído e/ou liberado?',
	'dashboards.examDetail.blocky': 'Block:',
	'dashboards.examDetail.numberOfExame': 'Exam No.:',
	'dashboards.examDetail.Material': 'Material',
	'dashboards.examDetail.doctorRequesting': 'Requesting Physician:',
	'dashboards.examDetail.typeAntibody': 'Antibody Type:',
	'dashboards.examDetail.typeSelect': 'Select type',
	'dashboards.examDetail.destiny': 'Destiny:',
	'dashboards.examDetail.antibodies': 'Antibodies:',
	'dashboards.examDetail.selectReagent': 'Select reagent',
	'dashboards.examDetail.addAntibodies': 'Add antibodies',
	'dashboards.examDetail.antigen': 'Antigen',
	'dashboards.examDetail.delete': 'Delete',
	'dashboards.examDetail.selectCase': 'Select case (block)',
	'dashboards.examDetail.favorites': 'Favorites',
	'dashboards.examDetail.saveFavorite': 'Save favorite',
	'dashboards.examDetail.saveFilter': 'Save filter',
	'dashboards.examDetail.favoriteName': 'Favorite name:',
	'dashboards.examDetail.stepCancellation': 'Step reopening',
	'dashboards.examDetail.justificationCancellation': 'Justification for reopening',
	'dashboards.examDetail.justificationForCancellation': 'Justification for cancellation',
	'dashboards.examDetail.justificationForReopening': 'Justification for reopening',
	'dashboards.examDetail.comeBack': 'Come back',
	'dashboards.examDetail.cancelStep': 'Reopen step',
	'dashboards.examDetail.cancellation': 'Cancellation:',
	'dashboards.examDetail.cancelingAllowed':
		'It is not allowed to cancel the receipt of material from reports with steps takenNão é permitido cancelar o recebimento de material de laudos com etapas realizadas',
	'dashboards.examDetail.confirmCancellation': 'Confirm cancellation',
	'dashboards.examDetail.deliveryCancellation': 'Delivery cancellation',
	'dashboards.examDetail.message.user': 'Messages - User',
	'dashboards.examDetail.message.report': 'Messages - Report',
	'dashboards.examDetail.message.conversations': 'Conversations',
	'dashboards.examDetail.message.subject': 'Subject:',
	'dashboards.examDetail.message.messageRecipient': 'Message recipient',
	'dashboards.examDetail.message.submit': 'Submit',
	'dashboards.examDetail.message.noConversationFound': 'No conversation found',
	'dashboards.examDetail.message.conversationTopic': 'Conversation topic:',
	'dashboards.examDetail.message.firstMessage': 'First Message:',
	'dashboards.examDetail.message.blockedMessages':
		'Sending messages is blocked, because this report has already been delivered!',
	'dashboards.examDetail.certificate': 'Certificate',
	'dashboards.examDetail.noCertificate': 'Not certified',
	'dashboards.examDetail.linkPastExams': 'Link previous exams to the report',
	'dashboards.examDetail.CIDReport': 'CID of the report',
	'dashboards.examDetail.wasNotTyped':
		'The report for the exam was not typed. Enter text in the report to include the CID',
	'dashboards.examDetail.wasNotTypedMorphology':
		'The report for the exam was not typed. Insert a text in the report to perform the Morphology',
	'dashboards.examDetail.notTyped':
		'The report for the exam was not typed. This report can only be recorded as pending. Check!',
	'dashboards.examDetail.newExam':
		'The new exam will use the same material as the linked exam',
	'dashboards.examDetail.link': 'Link',
	'dashboards.examDetail.noLink': 'Unlink',
	'dashboards.examDetail.linkReport': 'Link to report',
	'dashboards.examDetail.noLinkReport': 'Unlink from the report',
	'dashboards.examDetail.justification': 'Justification',
	'dashboards.examDetail.informCID': 'It is necessary to inform the CID',
	'dashboards.examDetail.setCID': 'Please define a main CID',
	'dashboards.examDetail.reportConclusionExam': 'Exam Completion Report',
	'dashboards.examDetail.reportAndConclusion': 'Laud and Finish',
	'dashboards.examDetail.requisitionReportProtocols':
		'Requisition of report protocols',
	'dashboards.examDetail.sampleCollection': 'Sample collection',
	'dashboards.examDetail.finalizeMaterialReceipt': 'Finalize Material Receipt',
	'dashboards.examDetail.toReceive': 'To receive',
	'dashboards.examDetail.externalExam': 'External Exam',
	'dashboards.examDetail.Unconformities': 'Unconformities',
	'dashboards.examDetail.attachment': 'Attachment',
	'dashboards.examDetail.docExternal': 'Doc. external',
	'dashboards.examDetail.Cancellation': 'Cancellation',
	'dashboards.examDetail.checklist': 'Check list',
	'dashboards.examDetail.savePending': 'Save as pending',
	'dashboards.examDetail.finalize': 'Finalize',
	'dashboards.examDetail.nextStep': 'Next step',
	'dashboards.examDetail.changeTopography': 'Change Topography',
	'dashboards.examDetail.bottleCancellation': 'Bottle Cancellation',
	'dashboards.examDetail.lastBottle':
		'This is the last bottle. If canceled, receipt will also be canceled and exam number will be lost.',
	'dashboards.examDetail.reportTopography': 'Report topography',
	'dashboards.examDetail.registerNewTopography': 'Register new topography',
	'dashboards.examDetail.removedBottle': 'Bottle removed',
	'dashboards.examDetail.addBottles': 'Bottle(s) added',
	'dashboards.examDetail.materialReceipt': 'Material receipt carried out',
	'dashboards.examDetail.deleteExternalDocument': 'Delete External Document',
	'dashboards.examDetail.receiptUsingExternalExam':
		'Receipt using external exam',
	'dashboards.examDetail.externalExamNumber': 'External Exam Number',
	'dashboards.examDetail.update': 'Update',
	'dashboards.examDetail.deleteExternalExam': 'Delete External Exam',
	'dashboards.examDetail.printIndividualTerm': 'Print individual term',
	'dashboards.examDetail.printer': 'Printer',
	'dashboards.examDetail.selectPrinter':
		'Select a printer for issuing the term',
	'dashboards.examDetail.printConsolidatedTerm': 'Print consolidated term',
	'dashboards.examDetail.addNonconformity': 'Add Nonconformity',
	'dashboards.examDetail.displayNoncompliance':
		'Display non-compliance in the final text of the report',
	'dashboards.examDetail.confirmPrintConsolidated':
		'Confirm and print consolidated',
	'dashboards.examDetail.confirmClose': 'Confirm and close',
	'dashboards.examDetail.printTerm': 'Print term',
	'dashboards.examDetail.noItems':
		'There are no items registered for the verification checklist',
	'dashboards.examDetail.receiptMaterialBlocked':
		'Receipt of material has been blocked',
	'dashboards.examDetail.questionnaireSuccessfully':
		'Questionnaire successfully answered',
	'dashboards.examDetail.openExam': 'Open exams:',
	'dashboards.examDetail.solicted': 'Asked by ',
	'dashboards.examDetail.performedBy': ' Run by',
	'dashboards.examDetail.executed': ' Executed',
	'dashboards.examDetail.step': ' Step',
	'dashboards.examDetail.pendingMacro': 'Pending macro',
	'dashboards.examDetail.Attachment': 'Attachment:',
	'dashboards.examDetail.fileAttachment': 'File Attachment',
	'dashboards.examDetail.deletearchive': 'Do you want to delete the file',
	'dashboards.examDetail.selectarchive': 'Select the file',
	'dashboards.examDetail.download': 'Download',
	'dashboards.examDetail.successAttached': 'File successfully attached!',
	'dashboards.examDetail.attachmentFailure': 'Could not attach file!',
	'dashboards.examDetail.attachmentError':
		'This file is already attached to the exam!',
	'dashboards.examDetail.fileRemoved': 'File removed successfully',
	'dashboards.examDetail.documentDescription': 'Document Description:',
	'dashboards.examDetail.receiveDocument': 'Receive document',
	'dashboards.examDetail.deliveredIn': ' Delivered in',
	'dashboards.examDetail.receivedIn': 'Document received in',
	'dashboards.examDetail.documentRegistered': 'Document registered!',
	'dashboards.examDetail.complementaryExamRemoved':
		'Complementary exam removed!',
	'dashboards.examDetail.additionalExamAdded': 'Additional exam added!',
	'dashboards.examDetail.updatedSupplementaryExam':
		'Updated supplementary exam!',
	'dashboards.examDetail.failedEditExam': 'Failed to edit exam',
	'dashboards.examDetail.questionnaireHistory': 'Questionnaire History:',
	'dashboards.examDetail.replyAgain': 'Reply again',
	'dashboards.examDetail.impeditive': 'Impeditive',
	'dashboards.examDetail.quiz': 'Quiz:',
	'dashboards.examDetail.finishReceivingMaterial':
		'Do you want to finish receiving material without informing new bottles?',
	'dashboards.examDetail.sampleOrigin': 'Sample origin location',
	'dashboards.examDetail.receivedBy': 'Received by',
	'dashboards.examDetail.processFor': 'Process for',
	'dashboards.examDetail.delegationTo': 'Delegation to',
	'dashboards.examDetail.receiptCompletedMaterial':
		'Receipt of completed material',
	'dashboards.examDetail.materialSavedPending': 'Material saved as pending',
	'dashboards.examDetail.errorExamExternal':
		'There was an error receiving the external exam',
	'dashboards.examDetail.bottleCanceled':
		'Bottle canceled by deletion of associated external exam',
	'dashboards.examDetail.receiptMaterialCanceled':
		'Receipt of material successfully canceled',
	'dashboards.examDetail.externalExamDeleted':
		'External exam number deleted successfully',
	'dashboards.examDetail.errorUpdateInformation':
		'An error occurred while trying to update the information',
	'dashboards.examDetail.unableCancelSteps': 'Unable to cancel steps',
	'dashboards.examDetail.grouped': 'Grouped',
	'dashboards.examDetail.general': 'General',
	'dashboards.examDetail.noAutoTextRegistered': 'No auto text registered',
	'dashboards.examDetail.shortcut': 'Shortcut',
	'dashboards.examDetail.defaultText': 'Default Text',
	'dashboards.examDetail.noAttachmentsRegistered': 'No attachments registered',
	'dashboards.examDetail.noClinicalReportExam':
		'There is no clinical report for this exam',
	'dashboards.examDetail.reportAddedReport':
		'Clinical report added to the report',
	'dashboards.examDetail.insertMapReport':
		'Insert macroscopic map in the report',
	'dashboards.examDetail.listBlocks': 'Block list',
	'dashboards.examDetail.noPreviousReportRegistered':
		'No previous report registered',
	'dashboards.examDetail.noHistoryRecorded': 'No history recorded',
	'dashboards.examDetail.dateChange': 'Date of change:',
	'dashboards.examDetail.insertReport': 'Insert in the report',
	'dashboards.examDetail.noBlades': 'There are no blades listed for this step!',
	'dashboards.examDetail.multipleExams': 'Multiple Exams',
	'dashboards.examDetail.includeClinicalReports': 'Include clinical reports',
	'dashboards.examDetail.crm': 'CRM',
	'dashboards.examDetail.reviewer': 'Reviewer',
	'dashboards.examDetail.notesSelectText': 'NOTES - Select text',
	'dashboards.examDetail.completeTheExam':
		'The Exam must be completed to access this step',
	'dashboards.examDetail.impedingNonCompliance':
		'There is an impeding non-compliance in the technical area',
	'dashboards.examDetail.fullyReleaseReport':
		'Do you want to fully release the report?',
	'dashboards.examDetail.fullRelease': 'Full release of the Report',
	'dashboards.examDetail.headsUp': 'Heads up!',
	'dashboards.examDetail.reportSave': 'Report saved successfully',
	'dashboards.examDetail.notAllowed': 'Authorization not allowed',
	'dashboards.examDetail.onlyDoctors': 'Only doctors can praise!',
	'dashboards.examDetail.reportNonCompliance':
		'This report has one or more non-conformities',
	'dashboards.examDetail.previousExams': 'Number of previous critical exam(s)',
	'dashboards.examDetail.laud': 'Laud',
	'dashboards.examDetail.laudPendent': 'Laud pending',
	'dashboards.examDetail.laudAndConclusion': 'Laud and Complete the Exam',
	'dashboards.examDetail.laudLecturer': 'Laud lecturer',
	'dashboards.examDetail.cassettes': 'Cassettes',
	'dashboards.examDetails.errata': 'ERRATA/ADDITIONAL INFORMATION',
	'dashboards.examDetails.years': 'years old',
	'dashboards.examDetails.months': 'months',
	'dashboards.examDetails.masculine': 'Masculine',
	'dashboards.examDetails.feminine': 'Feminine',
	'dashboards.examDetails.undefined': 'Undefined',
	'dashboards.examDetails.examCassetteGeneration': 'Exam Cassette Generation',
	'dashboards.examDetails.fullySubmittedExam':
		'Material fully submitted to the exam',
	'dashboards.examDetails.selectBottle': 'Select the bottle',
	'dashboards.examDetails.antigens': 'Antigens:',
	'dashboards.examDetails.selectMaterial': 'Select material',
	'dashboards.examDetails.registerNewMaterial': 'Register new material',
	'dashboards.examDetails.selectTechnician': 'Select the technician',
	'dashboards.examDetails.selectDoctor': 'Select the doctor',
	'dashboards.examDetails.typeDiscard': 'Discard type:',
	'dashboards.examDetails.selectTypeDisposal': 'Select the type of disposal',
	'dashboards.examDetails.doctorRequestingDisposal':
		'Doctor requesting the disposal:',
	'dashboards.examDetails.groupSelectedCassettes': 'Group selected cassettes',
	'dashboards.examDetails.canceled': 'Canceled',
	'dashboards.examDetails.canceledCassettes': 'Canceled cassettes',
	'dashboards.examDetails.laud': 'Report:',
	'dashboards.examDetails.medicalRecord': 'Medical record:',
	'dashboards.examDetails.datePerformed': 'Date performed:',
	'dashboards.examDetails.backToList': 'Back to list',
	'dashboards.examDetails.enableEditing': 'Enable editing',
	'dashboards.examDetails.saveChange': 'Save change',
	'dashboards.examDetails.addCassete': 'Add Cassette',
	'dashboards.examDetails.urgentUserExam':
		'Exam flagged as urgent on the macroscopic map by the user',
	'dashboards.examDetails.printReceptacleControl': 'Print Receptacle Control',
	'dashboards.examDetails.finishMacroscopicMap': 'Finish Macroscopic Map',
	'dashboards.examDetails.reopenMacroscopicMap': 'Reopen Macroscopic Map',
	'dashboards.examDetails.recorded': 'RECORDED',
	'dashboards.examDetails.canceledBlock': 'Cancel block',
	'dashboards.examDetails.shippingDate': 'Shipping Date:',
	'dashboards.examDetails.certifySelection': 'Certify Selection',
	'dashboards.examDetails.certifyAll': 'Certify All',
	'dashboards.examDetails.invalidCPF': 'Invalid SSN',
	'dashboards.examDetails.submitCertification': 'Submit for certification',
	'dashboards.examDetails.cpf': 'SSN:',
	'dashboards.examDetails.pin': 'PIN:',
	'dashboards.examDetails.certify': 'Certify',
	'dashboards.examDetails.reports': 'Reports:',
	'dashboards.examDetails.noncomplianceReport': 'Non-compliance of the report',
	'dashboards.examDetails.reportLabels': 'Report labels',
	'dashboards.examDetails.openExamReport': 'Open examinations of the report',
	'dashboards.examDetails.reportBaskets': 'Report baskets',
	'dashboards.examDetails.reportProtocol': 'Report protocol',
	'dashboards.examDetails.saved': 'Save changes to report text before exiting?',
	'dashboards.examDetails.saveEditions': 'Save editions',
	'dashboards.examDetails.launchAddendumReport':
		'Do you want to launch the addendum for the report already completed and/or released',
	'dashboards.examDetails.doctorPerformingReport':
		'Inform the performing physician of the report',
	'dashboards.examDetails.medicalReportReviewer':
		'Inform the reviewing physician of the report',
	'dashboards.examDetails.filterName': 'Filter name:',
	'dashboards.examDetails.visibleGroupUsers': 'Visible to group users:',
	'dashboards.examDetails.startupFilter': 'Set as startup filter',
	'dashboards.examDetails.materialReceipt': 'Material Receipt',
	'dashboards.examDetails.macro': 'Macroscopy',
	'dashboards.examDetails.micro': 'Microscopy',
	'dashboards.examDetails.fish': 'Fish',
	'dashboards.examDetails.cish': 'Cish',
	'dashboards.examDetails.histo': 'Histo',
	'dashboards.examDetails.notes': 'Grades',
	'dashboards.examDetails.conclusion': 'Conclusion',
	'dashboards.examDetails.printed': 'Printed',
	'dashboards.examDetails.term': 'Term:',
	'dashboards.examDetails.unitys': 'Units:',
	'dashboards.examDetails.periods': 'Periods:',
	'dashboards.examDetails.yearsOld': 'Years old:',
	'dashboards.examDetails.reset': 'Reset',
	'dashboards.examDetails.noPendingCertificates': 'No pending certificates',
	'dashboards.examDetails.billingStatus': 'Billing Status',
	'dashboards.examDetails.examStatus': 'Exam Status',
	'dashboards.examDetails.PatientSSN': 'Patient SSN',
	'dashboards.examDetails.reportDeliveredPortal': 'Informe entregado: Portal de exámenes',
	'dashboards.examDetails.imagesVivaceConnect': 'Images associated with the exam available for viewing on Vivace Connect',
	'dashboards.examDetails.microscopist': 'Microscopist',
	'dashboards.examDetails.tagNew': '(NEW)',
	'dashboards.examDetails.tagSaved': '(SAVED)',
	'dashboards.examDetails.tagCancelled': '(CANCELLED)',
	'dashboards.examDetails.externalExamFlask': 'Vial derived from external examination',
	'dashboards.examDetails.errorDate': 'Invalid date',

	/* 03.Sample Collection */

	/* 04.Graphics */

	'dashboards.graphics.graphics': 'Graphics',
	'dashboards.graphics.reportsDelivered': 'REPORTS DELIVERED PER PERIOD',
	'dashboards.graphics.historyNonCompliance':
		'HISTORY OF NON-COMPLIANCE BY PERIOD',
	'dashboards.graphics.averageTime': 'AVERAGE TIME OF STEPS',
	'dashboards.graphics.materialProductivity': 'MATERIAL PRODUCTIVITY',
	'dashboards.graphics.macroscopicMap': 'PRODUCTIVITY MACROSCOPIC MAP',
	'dashboards.graphics.selectScenery': 'Select a scenario',
	'dashboards.graphics.initial': 'Initial',
	'dashboards.graphics.last': 'Last',
	'dashboards.graphics.generate': 'Generate',
	'dashboards.graphics.reportsDeliveredMonth':
		'Total reports delivered per month',
	'dashboards.graphics.noDataPeriod': 'No data in the reported period',
	'dashboards.graphics.totalOfBottles': 'Total Bottles generated in the period',
	'dashboards.graphics.totalOfCassetes':
		'Total Cassettes generated in the period',
	'dashboards.graphics.freezingBlade': 'FREEZING_BLADE',

	/* 05.Histology */

	'dashboards.histology.histologyInclusion': 'Histology Inclusion',
	'dashboards.histology.histologyBlades': 'Histology Blades',
	'dashboards.histology.delegation': 'Delegation',
	'dashboards.histology.editBlock': 'Edit block',
	'dashboards.histology.consultCytotechnicians': 'Consult Cytotechnicians',
	'dashboards.histology.responsibleCytotechnician':
		'Responsible Cytotechnician',
	'dashboards.histology.detailsCytotechnicianDelegation':
		'Details of the Cytotechnician delegation',
	'dashboards.histology.exam': 'Exam',
	'dashboards.histology.noBladeFound': 'No blade found',
	'dashboards.histology.errorWritingBlades': 'Error writing blades',
	'dashboards.histology.successfullyDelegatedBlade':
		'Successfully delegated blade',
	'dashboards.histology.bladeSuccessfullyRequested':
		'Blade successfully requested',
	'dashboards.histology.successfullyCanceledDelegations':
		'Successfully canceled delegations',
	'dashboards.histology.cutout': 'Cutout',
	'dashboards.histology.biopsy': 'Biopsy',
	'dashboards.histology.autopsy': 'Autopsy',
	'dashboards.histology.piece': 'Piece',
	'dashboards.histology.withAntibodies': 'With antibodies',
	'dashboards.histology.sentries': 'Sentries',
	'dashboards.histology.selectBlocks': 'Select blocks',
	'dashboards.histology.clean': 'Clean',
	'dashboards.histology.cancelBlock': 'Cancel block',
	'dashboards.histology.cancelBlade': 'Cancel blade',
	'dashboards.histology.cancelThisBlock':
		'Are you sure you want to cancel this block?',
	'dashboards.histology.cancelThisBlade':
		'Are you sure you want to cancel this blade?',
	'dashboards.histology.nonconformitySuccessfullyAdded':
		'Nonconformity successfully added',
	'dashboards.histology.displayUpdatedSuccessfully':
		'Display updated successfully',
	'dashboards.histology.resolutionSavedSuccessfully':
		'Resolution saved successfully',
	'dashboards.histology.resolveIn': 'Resolved in',
	'dashboards.histology.includedIn': 'Included in',
	'dashboards.histology.inStep': 'in step',
	'dashboards.histology.blockedNonconformity':
		'Blocked for impeding nonconformity!',
	'dashboards.histology.successfullyMoved': 'Successfully moved',
	'dashboards.histology.puncture': 'Puncture',
	'dashboards.histology.autoInput': 'Auto Input',
	'dashboards.histology.createBlades': 'Create blades',
	'dashboards.histology.unableMoveSelectedMaterials':
		'Unable to move selected materials',

	/* 06.Cytology */

	'dashboards.cytology.geral': 'General Cytology',
	'dashboards.cytology.technical': 'All Technicians',
	'dashboards.cytology.danglingBlades': 'Pendant blades',
	'dashboards.cytology.bladesInProgress': 'Blades in progress',
	'dashboards.cytology.bladesReady': 'Blades ready',
	'dashboards.cytology.addBlades': 'Adding blades',
	'dashboards.cytology.editBlades': 'Edit blades',
	'dashboards.cytology.numberExam': 'Exam no.',
	'dashboards.cytology.blockCytology': 'Cytology block:',
	'dashboards.cytology.selectBlock': 'Select a cytology block (optional)',
	'dashboards.cytology.noBlock': 'No cytology blocks for this exam',
	'dashboards.cytology.technician': 'Technician:',
	'dashboards.cytology.pathologist': 'Pathologist:',
	'dashboards.cytology.cytology': 'Cytology',
	'dashboards.cytology.addCassetes': 'Adding cytology cassettes',
	'dashboards.cytology.bottles': 'Bottles:',
	'dashboards.cytology.selectBottle': 'Select bottle',
	'dashboards.cytology.numberOfCassetes': 'Number of cassettes:',
	'dashboards.cytology.fragmentsCassette': 'Fragments per cassette:',
	'dashboards.cytology.multipleFragments': 'Multiple fragments?',
	'dashboards.cytology.newCuts': 'New cuts',
	'dashboards.cytology.colors': 'Colorations:',
	'dashboards.cytology.selectAntigens': 'Select the antigens',
	'dashboards.cytology.selectMaterial': 'Select material',
	'dashboards.cytology.type': 'Type:',
	'dashboards.cytology.melanomaSentinel': 'Melanoma Sentinel',
	'dashboards.cytology.mamaSentry': 'Mama Sentinel',
	'dashboards.cytology.macroscopyTechnician': 'Macroscopic technician:',
	'dashboards.cytology.doctorMacroscopy': 'Doctor macroscopy:',
	'dashboards.cytology.selectDoctor': 'Select doctor',
	'dashboards.cytology.addCassete': 'Add cassette',
	'dashboards.cytology.cancel': 'CANCELED',
	'dashboards.cytology.allFields': 'Fill in all fields',
	'dashboards.cytology.successBlock':
		'Block created successfully. A blade has been generated for this block',
	'dashboards.cytology.selectTechnician': 'Select responsible technician',
	'dashboards.cytology.organizeLots': 'Organize Batches',
	'dashboards.cytology.organizeLot': 'Organize Batch',
	'dashboards.cytology.identificationNumber': 'Identification number',
	'dashboards.cytology.selectDestiny': 'Select Destination',
	'dashboards.cytology.nameOfExam': 'Exam name',
	'dashboards.cytology.nameOfPatient': 'Patient name',
	'dashboards.cytology.toAddBlades': 'Add blades',
	'dashboards.cytology.batchLabels': 'Batch labels',
	'dashboards.cytology.sendBatch': 'Send in batch',
	'dashboards.cytology.noItemsSend': 'No items to ship',
	'dashboards.cytology.printLabelsBatch': 'Print labels in batch',
	'dashboards.cytology.delegationBlades': 'Delegation of blades',
	'dashboards.cytology.consultCytotechnicians': 'Consult Cytotechnicians',
	'dashboards.cytology.statusDelegation':
		'Status of the Cytotechnician delegation',
	'dashboards.cytology.delegationDate': 'Delegation date',
	'dashboards.cytology.delegationCytotechnician':
		'Delegation for Cytotechnician:',
	'dashboards.cytology.selectCytotechnician': 'Select Cytotechnician',
	'dashboards.cytology.search': 'Search',
	'dashboards.cytology.delegateBlades': 'Delegate blades',
	'dashboards.cytology.removeDelegation': 'Remove delegation',
	'dashboards.cytology.cytotechnician': 'Cytotechnician',
	'dashboards.cytology.delegatedBlades': 'Delegated blades',
	'dashboards.cytology.remainingBlades': 'Remaining blades',
	'dashboards.cytology.code': 'Code',
	'dashboards.cytology.poweredBlades': 'Blade moved successfully',
	'dashboards.cytology.bladesNotMoved': 'Could not update blade',
	'dashboards.cytology.updateDate': 'Update date',
	'dashboards.cytology.deleteBlade': 'Erase the blade ',
	'dashboards.cytology.certaintyDelete':
		'Are you sure you want to erase this blade?',
	'dashboards.cytology.nonconformityToBlock': 'Insert nonconformity to block ',
	'dashboards.cytology.nonconformityToBlade':
		'Insert nonconformity in the blade ',
	'dashboards.cytology.nonconformityToReport':
		'Display non-compliance with the report',
	'dashboards.cytology.solve': 'Solve',
	'dashboards.cytology.nonComplianceDisplayed':
		'Non-compliance displayed in the final text of the report',
	'dashboards.cytology.listItems': 'List of column items ',
	'dashboards.cytology.toMove': 'to move',
	'dashboards.cytology.origin': 'Origin:',
	'dashboards.cytology.destiny': ' Destiny:',
	'dashboards.cytology.errorBlades': 'Error moving selected blades',
	'dashboards.cytology.successBlades': 'Blades moved Successfully',
	'dashboards.cytology.selectNonConformity':
		'It is necessary to select a nonconformity',
	'dashboards.cytology.bladesCreated': 'Blade created successfully',

	/* 07.Immunology */

	'dashboards.immunology.blockedImpedingNonconformity':
		'Blocked for impeding nonconformity!',
	'dashboards.immunology.unexpectedErrorOccurred':
		'An unexpected error occurred',
	'dashboards.immunology.immunologySlides': 'Immunology slides',

	/* 08.Task Control */

	'dashboards.taskControl.general': 'Task Control',
	'dashboards.taskControl.type': 'Choose a type',
	'dashboards.taskControl.initialFilter': 'Initial',
	'dashboards.taskControl.finalFilter': 'Last',
	'dashboards.taskControl.blocks': 'Blocks',
	'dashboards.taskControl.immune': 'Immune',
	'dashboards.taskControl.citologySlides': 'Citology slides',
	'dashboards.taskControl.histologySlides': 'Histology slides',
	'dashboards.taskControl.titleReportCitologySlides': 'CITOLOGY SLIDES',
	'dashboards.taskControl.titleReportHistologySlides': 'HISTOLOGY SLIDES',
	'dashboards.taskControl.exam': 'Exam',
	'dashboards.taskControl.block': 'Block',
	'dashboards.taskControl.fragments': 'No. of fragments',
	'dashboards.taskControl.macroscopist': 'Macroscopist',
	'dashboards.taskControl.typeCassette': 'Cassette type',
	'dashboards.taskControl.material': 'Material',
	'dashboards.taskControl.coloring': 'Coloring',
	'dashboards.taskControl.urgency': 'Urgency',
	'dashboards.taskControl.nc': 'NC',
	'dashboards.taskControl.printOut': 'Print Out',
	'dashboards.taskControl.dataSucessfully': 'Success',
	'dashboards.taskControl.itemUrgenciaYes': 'Yes',
	'dashboards.taskControl.itemUrgenciaNo': 'No',
	'dashboards.taskControl.itemNCYes': 'Yes',
	'dashboards.taskControl.itemNCNo': 'No',
	'dashboards.taskControl.blade': 'Blade',
	'dashboards.taskControl.linkedExam': 'Linked Exam',
	'dashboards.taskControl.bladeType': 'Blade Type',
	'dashboards.taskControl.pathologistDoctor': 'Pathologist',
	'dashboards.taskControl.medicalRecord': 'Medical Record',
	'dashboards.taskControl.dateCompleted': 'Date Completed',
	'dashboards.taskControl.antibody': 'Antibody',
	'dashboards.taskControl.clone': 'Clone',
	'dashboards.taskControl.species': 'Species',
	'dashboards.taskControl.status': 'Status',
	'dashboards.taskControl.noResult': 'No results found',
	'dashboards.taskControl.receptacleControl': 'RECEPTACLE CONTROL',
	'dashboards.taskControl.responsibleMacro': 'Macro responsible',
	'dashboards.taskControl.technicalManager': 'Technical manager',
	'dashboards.taskControl.patient': 'Patient',
	'dashboards.taskControl.canceled': 'Canceled',

	/* 09.Doctor Tasks */
	'dashboards.doctorTasks.selectSearchType': 'Select search type',
	'dashboards.doctorTasks.selectResponsibleReviewer': 'Select responsible reviewer',
	'dashboards.doctorTasks.examsToReview': 'Exams to review',
	'dashboards.doctorTasks.revisedExams': 'Revised exams',
	'dashboards.doctorTasks.reportDetails': 'Report details',
	'dashboards.doctorTasks.releaseBatchReports': 'Release batch reports',
	'dashboards.doctorTasks.releaseBatch': 'Batch release',
	'dashboards.doctorTasks.orderNumber': 'Nº order',
	'dashboards.doctorTasks.examNumber': 'Nº exam',
	'dashboards.doctorTasks.insert': 'Insert',
	'dashboards.doctorTasks.orderAlreadyEntered': 'Order has already been entered',
	'dashboards.doctorTasks.ordersReleasedSuccessfully': 'Orders released successfully',
	'dashboards.doctorTasks.partiallyReleasedOrders': 'Some orders were not released. These will remain on the grid',
	'dashboards.doctorTasks.unreleasedOrders': 'There was a problem. Orders have not been released',
	'dashboards.doctorTasks.enterYourSSN': 'Enter your SSN',
	'dashboards.doctorTasks.enterYourSSN': 'Enter your PIN',

	/* 10.Discard Material */

	'dashboards.disposalMaterials.initialFilter': 'Initial',
	'dashboards.disposalMaterials.finalFilter': 'Last',
	'dashboards.disposalMaterials.type.special': 'Special',
	'dashboards.disposalMaterials.type.burial': 'Burial',
	'dashboards.disposalMaterials.type.standard': 'Standard',
	'dashboards.disposalMaterials.discardReports': 'REPORT ON DISPOSAL MATERIALS',
	'dashboards.disposalMaterials.discardedReports':
		'REPORT OF DISPOSED MATERIALS',
	'dashboards.disposalMaterials.signatureCRM': 'Subscription - CRM',
	'dashboards.disposalMaterials.general': 'Disposal of Materials',
	'dashboards.disposalMaterials.discardedMaterials': 'Discarded Materials',
	'dashboards.disposalMaterials.reports': 'Reports',
	'dashboards.disposalMaterials.chooseOne': 'Choose one',
	'dashboards.disposalMaterials.disposalDate': 'Disposal Date',
	'dashboards.disposalMaterials.lotDescription': 'Lot Description',
	'dashboards.disposalMaterials.items': 'Items',
	'dashboards.disposalMaterials.examNumber': 'Exam Number',
	'dashboards.disposalMaterials.totalWeight': 'Total weight',
	'dashboards.disposalMaterials.user': 'User',
	'dashboards.disposalMaterials.reportType': 'Report type',
	'dashboards.disposalMaterials.standardDiscard': 'Standard discard',
	'dashboards.disposalMaterials.specialDisposal': 'Special disposal',
	'dashboards.disposalMaterials.burialDisposal': 'Burial disposal',
	'dashboards.disposalMaterials.burialReport': 'Burial report',
	'dashboards.disposalMaterials.requestDate': 'Order Date',
	'dashboards.disposalMaterials.discardDate': 'Disposal Date',
	'dashboards.disposalMaterials.dueDate': 'Expiration Date',
	'dashboards.disposalMaterials.dateSolicitation': 'Request date',
	'dashboards.disposalMaterials.materialDescription': 'Material description',
	'dashboards.disposalMaterials.daysExpire': 'Days to expire',
	'dashboards.disposalMaterials.bottleIdentification': 'Bottle Identification',
	'dashboards.disposalMaterials.examNumber': 'Exam Number',
	'dashboards.disposalMaterials.requestNumber': 'Request number',
	'dashboards.disposalMaterials.patient': 'Patient',
	'dashboards.disposalMaterials.toDiscard': 'Discard',
	'dashboards.disposalMaterials.discardAll': 'Discard all',
	'dashboards.disposalMaterials.description': 'Description',
	'dashboards.disposalMaterials.restore': 'Restore',
	'dashboards.disposalMaterials.restoreAll': 'Restore all',
	'dashboards.disposalMaterials.printOut': 'Print out',
	'dashboards.disposalMaterials.filters': 'Filters',
	'dashboards.disposalMaterials.burial': 'Burial',
	'dashboards.disposalMaterials.noResult': 'No results found',
	'dashboards.disposalMaterials.dataSucessfully': 'Success',
	'dashboards.disposalMaterials.table.exam': 'Exam',
	'dashboards.disposalMaterials.table.request': 'Request',
	'dashboards.disposalMaterials.table.dayExpire': 'Days to expire',
	'dashboards.disposalMaterials.table.patient': 'Patient (Civil Registry)',
	'dashboards.disposalMaterials.table.socialName': 'Social name',
	'dashboards.disposalMaterials.table.weight': 'Weight (g)',
	'dashboards.disposalMaterials.table.material': 'Material',
	'dashboards.disposalMaterials.table.bottle': 'Bottle',
	'dashboards.disposalMaterials.table.nobottle':
		'This report does not have any bottle!',
	'dashboards.disposalMaterials.table.requestDate': 'Request Date',
	'dashboards.disposalMaterials.table.expirationDate': 'Expiration Date',
	'dashboards.disposalMaterials.table.deliveryDate': 'Delivery date',
	'dashboards.disposalMaterials.table.totalDiscard': 'Total Discard:',
	'dashboards.disposalMaterials.table.materialsTotalDiscard':
		'Total Discarded Materials',
	'dashboards.disposalMaterials.table.items': 'Items',
	'dashboards.disposalMaterials.table.exams': 'Exams',
	'dashboards.disposalMaterials.table.user': 'User',
	'dashboards.disposalMaterials.table.observationDiscard':
		'Discard observation',
	'dashboards.disposalMaterials.table.descriptionLot': 'Lot Description',
	'dashboards.disposalMaterials.modal.disposalInformation':
		'Disposal information',
	'dashboards.disposalMaterials.modal.weightG': 'Weight in (G):',
	'dashboards.disposalMaterials.modal.weightKG': 'Weight in (KG):',
	'dashboards.disposalMaterials.modal.observation': 'Observation:',
	'dashboards.disposalMaterials.modal.reasonDiscard': 'Reason for discard',
	'dashboards.disposalMaterials.modal.wantPrint': 'Want to Print',
	'dashboards.disposalMaterials.modal.cancel': 'Cancel',
	'dashboards.disposalMaterials.modal.confirm': 'Confirm',

	/* 11.Material Archiving */

	'general.materialArchiving.user': 'User',
	'general.materialArchiving.error': 'Error',
	'general.materialArchiving.save': 'Save',
	'general.materialArchiving.description': 'Description',
	'general.materialArchiving.toFile': 'To File',
	'general.materialArchiving.material': 'Material',
	'general.materialArchiving.type': 'Type',
	'general.materialArchiving.selectType': 'Select Type',
	'general.materialArchiving.selectDestination': 'Select destination',
	'general.materialArchiving.selectTheApplicant': 'Select the applicant',
	'general.materialArchiving.close': 'Close',
	'general.materialArchiving.toMove': 'To move',
	'general.materialArchiving.confirm': 'Confirm',
	'general.materialArchiving.initial': 'Initial',
	'general.materialArchiving.final': 'Last',
	'general.materialArchiving.identification': 'Identification',
	'general.materialArchiving.noResultsFound': 'No results found',
	'general.materialArchiving.patient': 'Patient',
	'general.materialArchiving.socialName': 'Social Name',
	'general.materialArchiving.technician': 'Technician',
	'general.materialArchiving.requestDate': 'Request Date',
	'general.materialArchiving.expectedReturnDate': 'Expected Return Date',
	'general.materialArchiving.expectedDate': 'Expected date',
	'general.materialArchiving.filingDate': 'Filing Date',
	'general.materialArchiving.completionDate': 'Completion Date',
	'general.materialArchiving.dateOfChange': 'Date of change',
	'general.materialArchiving.completed': 'Completed',
	'general.materialArchiving.cancel': 'Cancel',
	'general.materialArchiving.details': 'Details',
	'general.materialArchiving.request': 'Request',
	'general.materialArchiving.audit': 'Audit',
	'general.materialArchiving.requested': 'Requested',
	'general.materialArchiving.addRequisition': 'Add Requisition',
	'general.materialArchiving.archived': 'Archived',
	'general.materialArchiving.archiveds': 'Archiveds',
	'general.materialArchiving.requester': 'Requester',
	'general.materialArchiving.theBlock': 'the block',
	'general.materialArchiving.block': 'Block',
	'general.materialArchiving.blocks': 'Blocks',
	'general.materialArchiving.blocksAndBlades': 'Blocks and Blades',
	'general.materialArchiving.blockMoved': 'Block Moved',
	'general.materialArchiving.movedBlade': 'Moved Blade',
	'general.materialArchiving.successfully': 'successfully',
	'general.materialArchiving.success': 'Success',
	'general.materialArchiving.theBlade': 'the blade',
	'general.materialArchiving.blade': 'Blade',
	'general.materialArchiving.blades': 'Blades',
	'general.materialArchiving.anErrorOccurred': 'An error occurred while moving',
	'general.materialArchiving.successfullyRemoved':
		'Successfully removed from archive',
	'general.materialArchiving.materialType': 'Material type',
	'general.materialArchiving.examNumber': 'Exam number',
	'general.materialArchiving.exam': 'Exam',
	'general.materialArchiving.confirmationManualArchiving':
		'Confirmation for manual archiving',
	'general.materialArchiving.reason': 'Reason',
	'general.materialArchiving.informTheReason': 'Inform the reason',
	'general.materialArchiving.location': 'Physical location of the block and/or blade',
	'general.materialArchiving.materialLocation': 'Material Physical Location',
	'general.materialArchiving.previousLocations': 'Previous locations',
	'general.materialArchiving.registerNewLocation': 'Register new location',
	'general.materialArchiving.manualArchiving': 'Manual archiving',
	'general.materialArchiving.archiving': 'Archiving',
	'general.materialArchiving.archivingDoneSuccessfully':
		'Archiving done successfully',
	'general.materialArchiving.medicalRecord': 'Medical record',
	'general.materialArchiving.destiny': 'Destiny',
	'general.materialArchiving.report': 'Report',
	'general.materialArchiving.operation': 'Operation',
	'general.materialArchiving.maximumCharacters': 'Maximum characters reached',
	'general.materialArchiving.remain': 'Remain',
	'general.materialArchiving.characters': 'characters',
	'general.materialArchiving.informTheLocationStored':
		'Inform the location where the material will be stored.',
	'general.materialArchiving.removeArchive':
		'Are you sure you want to remove from the archive the ',
	'general.materialArchiving.remove': 'Remove',
	'general.materialArchiving.reportType': 'Report type',
	'general.materialArchiving.chooseOne': 'Choose one ',
	'general.materialArchiving.exportCSV': 'Export CSV',
	'general.materialArchiving.printOut': 'Print',
	'general.materialArchiving.uninformed': 'Uninformed',
	'general.materialArchiving.AUDITREPORTOFFILINGANDMATERIALREQUEST':
		'AUDIT REPORT OF FILING AND MATERIAL REQUEST',
	'general.materialArchiving.deliveredToThePatient': 'Delivered to the patient',
	'general.materialArchiving.requestCancellationCompleted':
		'Request cancellation successfully completed!',
	'general.materialArchiving.shouldBeForwardedToHistologySlides':
		'Should be forwarded to histology slides',
	'general.materialArchiving.shouldBeForwardedImmunologySlides':
		'Should be forwarded to immunology slides',
	'general.materialArchiving.materialRequisitionCancellation':
		'Material Requisition Cancellation',
	'general.materialArchiving.noBlocksOrSlidesAvailable':
		'This exam has no blocks or slides available',
	'general.materialArchiving.requestMadeSuccessfully':
		'Request made successfully',
	'general.materialArchiving.confirmationForMaterialRequisition':
		'Confirmation for material requisition',
	'general.materialArchiving.materialRequisitionRequestInformation':
		'Material requisition request information',
	'general.materialArchiving.ArchivingReason': 'Location',

	/* 12.Reports */

	'dashboards.reports.criticalReport': 'Critical Report',
	'dashboards.reports.disposalMaterials': 'Disposal of Materials',
	'dashboards.reports.archiving': 'Archiving',
	'dashboards.reports.taskControl': 'Task Control',
	'dashboards.reports.requestsPanel': 'Requests Panel',
	'dashboards.reports.reportsCID': 'Reports S/ CID',
	'dashboards.reports.invoicing': 'Invoicing',
	'dashboards.reports.all': 'All',
	'dashboards.reports.doctorResponsible': 'Doctor responsible',
	'dashboards.reports.searchType': 'Search type',
	'dashboards.reports.selectOption': 'Select an option',
	'dashboards.reports.initial': 'Initial',
	'dashboards.reports.last': 'Last',
	'dashboards.reports.printOut': 'Print out',
	'dashboards.reports.deliveryDate': 'Delivery date',
	'dashboards.reports.requestDate': 'Request date',
	'dashboards.reports.noResults': 'No Results',
	'dashboards.reports.examNumber': 'Exam number',
	'dashboards.reports.requestNumber': 'Request number',
	'dashboards.reports.patientName': 'Patient name',
	'dashboards.reports.observationReport': 'Observation of the report',
	'dashboards.reports.examType': 'Exam type',
	'dashboards.reports.urgent': 'Urgent',
	'dashboards.reports.totalCriticalExams': 'Total critical exams:',
	'dashboards.reports.totalReports': 'Total Reports:',
	'dashboards.reports.noResultsFound': 'No results found',
	'dashboards.reports.exam': 'Exam',
	'dashboards.reports.status': 'Status',
	'dashboards.reports.patientCivilRegistry': 'Patient (Civil Registry)',
	'dashboards.reports.socialName': 'Social Name',
	'dashboards.reports.doctor': 'Doctor',
	'dashboards.reports.type': 'Type',
	'dashboards.reports.dateRequest': 'Request Date',
	'dashboards.reports.medicalRecord': 'Medical Record',
	'dashboards.reports.notifications': 'Notifications',
	'dashboards.reports.yes': 'Yes',
	'dashboards.reports.no': 'No',
	'dashboards.reports.bottle': 'Bottle',
	'dashboards.reports.material': 'Material',
	'dashboards.reports.deliverydates': 'Delivery date',
	'dashboards.reports.discardRequestingPhysician':
		'Discard requesting physician',
	'dashboards.reports.discardDate': 'Discard date',
	'dashboards.reports.materialSpecial': 'SPECIAL DISPOSAL MATERIALS REPORT',
	'dashboards.reports.specialRecord': 'SPECIAL DISPOSAL RECORD',
	'dashboards.reports.subscriptionCRM': 'Subscription - CRM',
	'dashboards.reports.burialRequestingPhysician':
		'Physician requesting the burial',
	'dashboards.reports.reportBurial':
		'REPORT ON MATERIALS FOR DISPOSAL OF PARTS FOR BURIAL',
	'dashboards.reports.registrationBurial': 'REGISTRATION OF BURIAL MATERIALS',
	'dashboards.reports.doctorMacro': 'Doctor resp. Macro',
	'dashboards.reports.materialArchiving': 'Material Archiving',
	'dashboards.reports.materialRequest': 'Material request',
	'dashboards.reports.dateArchiving': 'Filing Date',
	'dashboards.reports.observation': 'Observation',
	'dashboards.reports.reportArchiving': 'MATERIAL ARCHIVING REPORT',
	'dashboards.reports.requester': 'Requester',
	'dashboards.reports.reportMaterialRequest': 'MATERIAL REQUEST REPORT',
	'dashboards.reports.returnDate': 'Expected date for return',
	'dashboards.reports.lastDate': 'Final date',
	'dashboards.reports.examCID': 'Total exams without CID:',
	'dashboards.reports.performingPhysician': 'Executing Physician',
	'dashboards.reports.totalExam': 'Total exams:',
	'dashboards.reports.released': 'Released',
	'dashboards.reports.partiallyReleased': 'Partially released',
	'dashboards.reports.inProgress': 'In progress',
	'dashboards.reports.ready': 'Ready',
	'dashboards.reports.pending': 'Pending',
	'dashboards.reports.finished': 'Finished',
	'dashboards.reports.criticalReportContact': 'Critical report contact record',
	'dashboards.reports.notifiedRequestingPhysician':
		'Notified requesting physician:',
	'dashboards.reports.enterDoctor': 'Enter the doctor',
	'dashboards.reports.phone': 'Telephone',
	'dashboards.reports.comment': 'Comment:',
	'dashboards.reports.notificationSuccess': 'Notification created successfully',
	'dashboards.reports.criticalReportNotifications':
		'CRITICAL REPORT NOTIFICATIONS',
	'dashboards.reports.externalExamNumber': 'External exam number',
	'dashboards.reports.materialDeliveryDate': 'Material delivery date',
	'dashboards.reports.expectedDeliveryDate': 'Expected delivery date',
	'dashboards.reports.notification': 'Notification',
	'dashboards.reports.materialDelivered': 'Material delivered',
	'dashboards.reports.estimatedDelivery': 'Estimated delivery time',
	'dashboards.reports.delivery': 'Delivery',
	'dashboards.reports.criticalReports': 'CRITICAL REPORTS',
	'dashboards.reports.examNoNotification': 'This exam has no notification',
	'dashboards.reports.examNoCassete': 'This exam has no cassette',
	'dashboards.reports.noItemsFound': 'No items found',
	'dashboards.reports.examNotFound': 'The exam was not found',
	'dashboards.reports.informIndication':
		'Do you want to inform the indication?',
	'dashboards.reports.indication': 'Recommendation:',
	'dashboards.reports.burialReport': 'REPORT FOR BURIAL',
	'dashboards.reports.typeCassete': 'Cassette type',
	'dashboards.reports.fragments': 'Fragments',
	'dashboards.reports.medicalRecordRGHC': 'Medical Record / RGHC',
	'dashboards.reports.yearsOld': 'Years Old',
	'dashboards.reports.antibodies': 'Antibodies',
	'dashboards.reports.inconclusive': 'Inconclusive',
	'dashboards.reports.negative': 'Negative',
	'dashboards.reports.positive': 'Positive',
	'dashboards.reports.antigenRequisitionReport': 'ANTIGEN REQUEST REPORT',
	'dashboards.reports.printPreview': 'Print preview',

	/* 13.Requests Panel */

	'general.requestsPanel.title': 'Requests Panel',
	'general.requestsPanel.status': 'Status',
	'general.requestsPanel.requestChangedSuccessfully':
		'Request changed successfully',
	'general.requestsPanel.all': 'All',
	'general.requestsPanel.error': 'Error',
	'general.requestsPanel.type': 'Type',
	'general.requestsPanel.initial': 'Initial',
	'general.requestsPanel.final': 'Last',
	'general.requestsPanel.selectType': 'Select Type',
	'general.requestsPanel.selectStatus': 'Select Status',
	'general.requestsPanel.selectAll': 'Select All',
	'general.requestsPanel.close': 'Close',
	'general.requestsPanel.save': 'Save',
	'general.requestsPanel.date': 'Date',
	'general.requestsPanel.success': 'Success',
	'general.requestsPanel.request': 'Request',
	'general.requestsPanel.requested': 'Requested',
	'general.requestsPanel.requestDate': 'Request Date',
	'general.requestsPanel.registrationDate': 'Registration date',
	'general.requestsPanel.dateOfChange': 'Date of change',
	'general.requestsPanel.requestDetails': 'Request details',
	'general.requestsPanel.requestingUser': 'Requesting User',
	'general.requestsPanel.executingUser': 'Executing User',
	'general.requestsPanel.comment': 'Comment',
	'general.requestsPanel.registrationOfRequests': 'Registration of requests',
	'general.requestsPanel.requester': 'Requester',
	'general.requestsPanel.performer': 'Performer',
	'general.requestsPanel.identifier': 'Identifier',
	'general.requestsPanel.searchType': 'Search Type',
	'general.requestsPanel.selectAnOption': 'Select an option',
	'general.requestsPanel.doctorResponsible': 'Doctor responsible',
	'general.requestsPanel.initial': 'Initial',
	'general.requestsPanel.final': 'Last',
	'general.requestsPanel.patient': 'Patient',
	'general.requestsPanel.medicalRecord': 'Medical record',
	'general.requestsPanel.print': 'Print',
	'general.requestsPanel.bottle': 'Bottle',
	'general.requestsPanel.block': 'Block',
	'general.requestsPanel.selectBlock': 'Select Block',
	'general.requestsPanel.exam': 'Exam',
	'general.requestsPanel.totalExams': 'Total Exams',
	'general.requestsPanel.examNumber': 'Exam number',
	'general.requestsPanel.totalRequests': 'Total requests',
	'general.requestsPanel.noResultsFound': 'No results found',
	'general.requestsPanel.colorations': 'Colorations',
	'general.requestsPanel.selectColors': 'Select the colors',
	'general.requestsPanel.errorListingItems': 'Error listing items',
	'general.requestsPanel.necessaryInformType':
		'It is necessary to inform the type',
	'general.requestsPanel.necessaryInformBottle':
		'It is necessary to inform the bottle',
	'general.requestsPanel.necessaryInformBlock':
		'It is necessary to inform the block',
	'general.requestsPanel.requestCreatedSuccessfully':
		'Request created successfully',
	'general.requestsPanel.requestsMade': 'REQUESTS MADE',
	'general.requestsPanel.signature': 'Signature',
	'general.requestsPanel.newCut': 'New cut',
	'general.requestsPanel.deepening': 'Deepening',
	'general.requestsPanel.inProgress': 'In progress',
	'general.requestsPanel.done': 'Done',

	/* 14.Sample Tracking - NEW */

	'dashboards.sample.fillAllFormFields': 'Fill in all form fields',
	'dashboards.sample.userOf': 'User of',
	'dashboards.sample.userFor': 'User for',
	'dashboards.sample.processOf': 'Process of',
	'dashboards.sample.process': 'Process',
	'dashboards.sample.processFor': 'Process for',
	'dashboards.sample.searchByExamNumber': 'Search by exam number',
	'dashboards.sample.clearSelected': 'Clear selected',
	'dashboards.sample.users': 'Users',
	'dashboards.sample.fillTheCollection':
		'Fill in all the information for the collection',
	'dashboards.sample.thisItemHasAdded': 'This item has already been added',
	'dashboards.sample.bladesCreatedSuccessfully!':
		'Blades created successfully!',
	'dashboards.sample.itemsMovedSuccessfully': 'Items moved successfully',
	'dashboards.sample.changeTheType': 'Do you really want to change the type?',
	'dashboards.sample.tableDataErased': 'Table data will be erased',
	'dashboards.sample.technicianName': 'Technician name',

	/* 15.Error Page */

	'error.title': 'There was an error on the Page',
	'error.code': 'The error code encountered was',
	'error.gobackhome': 'Back to Home',
	'error.notfoundpage': 'Page not found',
	'error.notfoundpagedesc': 'The requested page could not be found',

	/* 16.Messages */

	'message.noExamFound': 'No exam found',
	'message.examFound': 'Exam(s) found',
	'message.loading': 'Loading...',
	'message.maxlength': 'Maximum characters reached',
	'message.remaining.more': '{char} Characters left',
	'message.remaining.only': '{char} Character left',
	'message.errorEditor': 'Error loading editor. Reload the page to try again',
	'message.welcome': 'Welcome(a)',
	'message.expired': 'Session expired',
	'message.userNotCheck': 'User does not check',
	'message.notPermission': 'Permission not found',
	'message.permissionNot': 'Permission does not check',
	'messages.noChargeReport': 'Unable to load the Report!',
	'message.expired.renewSession' : 'You will be logged out in <b></b> seconds <div class="mt-4"></div> <button id="increase" class="btn btn-primary"> continue session </button><br/><br/>',

	/* 17.Period */
	'period.name': 'Period',
	'period.order.request': 'Order period',
	'period.delegation': 'Delegation period',
	'period.all': 'All',
	'period.today': 'Today',
	'period.yesterday': 'Yesterday',
	'period.daybeforeyesterday': 'Before yesterday',
	'period.has1week': '1 week ago',
	'period.has15days': 'There are 15 days',
	'period.has1month': '1 Month ago',
	'period.has2months': '2 Months ago',
	'period.has3months': '3 Months ago',
	'period.has6months': '6 Months ago',
	'period.has1year': '1 Year ago',
	'period.other': 'Other',
	'period.datestart': 'Start Date',
	'period.dateend': 'End Date',

	/* 18.Checklist */
	'checklist.resp': 'Response',
	'checklist.modalTitle': 'Sample receipt checklist',

	/* .Encaminhamento */

	'dashboards.referral.referral': 'Referral to 2nd opinion',
	'dashboards.referral.doctorAssigned': 'Doctor assigned to 2nd opinion',

	/* Entrega de resultados */
	'dashboard.resultsScreen.modal.deliveryofexams': 'Delivery of exams',
	'dashboard.resultsScreen.modal.carryoutdelivery': 'Make Delivery',
	'dashboard.resultsScreen.modal.history': 'Historic',
	'dashboard.resultsScreen.modal.deliveredto': 'Delivered to:',
	'dashboard.resultsScreen.modal.cpf': ' SSN:',
	'dashboard.resultsScreen.modal.notes': 'Notes',
	'dashboard.resultsScreen.modal.internalnotes': 'Internal Notes',
	'dashboard.resultsScreen.modal.noteswillnotbeincludedinthedeliveryprotocol':
		' * Notes will not be included in the delivery protocol',
	'dashboard.resultsScreen.modal.externaldocumentreturnedpatient':
		'External document(s) to return to the patient:',
	'dashboard.resultsScreen.modal.examresult': 'Exam Result',
	'dashboard.resultsScreen.modal.deliveryprotocol': 'Delivery protocol',
	'dashboard.resultsScreen.modal.delivermaterial': 'Deliver Material',
	'dashboard.resultsScreen.modal.deliverycanceled': 'Delivery Canceled',
	'dashboard.resultsScreen.modal.deliveredby': 'Delivered by',
	'dashboard.resultsScreen.modal.canceled': 'Cancel',
	'dashboard.resultsScreen.modal.deliver': 'Deliver',
	'dashboard.resultsScreen.modal.confirm': 'Confirm',
	'dashboard.resultsScreen.modal.sheets': 'Blades:',
	'dashboard.resultsScreen.modal.block': 'Blocks:',
	'dashboard.resultsScreen.modal.selectdelivereditems':
		'Select delivered items',
	'dashboard.resultsScreen.modal.deliveredin': '; delivered in',
	'dashboard.resultsScreen.modal.description': 'Description: ',
	'dashboard.resultsScreen.modal.type': 'Type: ',
	'dashboard.resultsScreen.modal.reportViewedBy': 'Report viewed/printed by ',
	'dashboard.resultsScreen.modal.originPortal': 'via Exam Portal',
	'dashboards.examDetails.reportDeliveredPortal': 'Report delivered: Exam Portal',

	/* Modal óbito */
	'data.obito':'Death data',
	'modalobito.title':'Death information',
	'dateandhour.obito':'Date and time of death:',
	'observations.obito':'Observations:',
	'messages.obito.updateSucess': 'Information updated successfully!',
	'messages.obito.updateError': 'There was an error updating the information!',
	'messages.obito.insertSucess': 'Information inserted successfully!',
	'messages.obito.insertError': 'There was an error inserting information!',
	'messages.obito.removeSucess': 'Information removed successfully!',
	'messages.obito.removeError': 'There was an error removing information!',

	/* Agrupar exames */
	'dashboard.groupExams.modal.title': 'Group order exams upon receipt of material',
	'dashboard.groupExams.modal': 'Group exams',
};



// WEBPACK FOOTER //
// ./src/lang/locales/en_US.js